export default __webpack_public_path__ + "static/media/guide-9.4a5b842c.png";